/** Kleine Helfer, die mehrere Module brauchen. */

/** Ersetzt einen Fallback-Link (<a href>) durch einen <button>, behält Inhalt und Klassen. */
export function linkToButton(link) {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = link.className;
  button.innerHTML = link.innerHTML;
  for (const attr of link.attributes) {
    if (attr.name.startsWith('data-') || attr.name.startsWith('aria-')) button.setAttribute(attr.name, attr.value);
  }
  button.removeAttribute('aria-current');
  link.replaceWith(button);
  return button;
}

export const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';

/** Inhalt eines geschlossenen <details> (außer seinem <summary>) ist nicht fokussierbar, hat in Chromium aber trotzdem einen offsetParent. */
const inClosedDetails = (el) => {
  const details = el.closest('details:not([open])');
  return !!details && el.closest('summary')?.parentElement !== details;
};

/** Hält den Fokus innerhalb der übergebenen Container (z. B. Header + mobiles Menü). */
export function trapFocus(containers, event) {
  if (event.key !== 'Tab') return;
  const items = containers
    .flatMap((c) => [...c.querySelectorAll(FOCUSABLE)])
    .filter((el) => (el.offsetParent !== null && !inClosedDetails(el)) || el === document.activeElement);
  if (!items.length) return;
  const first = items[0];
  const last = items[items.length - 1];
  if (event.shiftKey && document.activeElement === first) { last.focus(); event.preventDefault(); }
  else if (!event.shiftKey && document.activeElement === last) { first.focus(); event.preventDefault(); }
}

export const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
